import React from "react";
import "./Home.css";
import patientImage1 from "./patient1.jpg";
import patientImage2 from "./patient2.jpg";
import therapistImage1 from "./therapist1.jpg";
import toolkitImage from "./ocd-complete-therapy-toolkit.png";
import exposureImage from "./exposure-image.png";
import BookPromo from "./BookPromo";
import bookCover from "./book-cover.jpg";

import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Homepage = () => {
  return (
    <>
      <Navbar />
      <div className="homepage-container">
        <header className="homepage-header">
          <h1>The Specialized Platform Built Exclusively for OCD Treatment</h1>
          <h2>
            Transform evidence-based OCD treatment with digital precision and
            extend your therapeutic reach between sessions.
            <br />
          </h2>
          <div className="header-content">
            <div className="text-content">
              <br />
              <p>
                OCDSerenity empowers mental health providers with purpose-built
                tools that enhance the therapeutic relationship and treatment
                protocols unique to OCD. Our platform bridges the gap between
                weekly appointments with structured support tools, while
                maintaining the highest standards of security and HIPAA
                compliance.
              </p>
              <br />
            </div>
          </div>
          <div>
            <br />
          </div>
        </header>

        {/* New Mobile Apps Section */}
        <section className="homepage-header">
          <h2>🚀 One WEB Platform & Two Powerful Mobile Apps for Your OCD Journey</h2>
          <p style={{ fontSize: "20px", textAlign: "center", maxWidth: "800px", margin: "0 auto 40px auto" }}>
            Choose the right tool for your needs - or download both! Our specialized mobile apps work together to provide comprehensive OCD support.
          </p>

          <div className="mobile-apps-container" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "40px", margin: "40px 0" }}>

            {/* App 1 - Toolkit */}
            <div style={{
              padding: "30px",
              borderRadius: "15px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              textAlign: "center",
              border: "3px solid #007bff"
            }}>
              <div style={{ backgroundColor: "#007bff", color: "white", padding: "10px 20px", borderRadius: "20px", display: "inline-block", marginBottom: "20px", fontSize: "14px", fontWeight: "bold" }}>
                MOST POPULAR
              </div>
              <h3 style={{ color: "#007bff", marginBottom: "20px" }}>
                <strong>🧰 OCD Complete Therapy Toolkit</strong>
              </h3>
              <a
                href="https://play.google.com/store/apps/details?id=com.olivier7355.ocdserenitymobile"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={toolkitImage}
                  alt="OCD Complete Therapy Toolkit App"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "15px",
                    margin: "20px 0",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)"
                  }}
                />
              </a>
              <p style={{ fontSize: "16px", lineHeight: "1.6", marginBottom: "20px" }}>
                <strong>Your complete OCD management suite!</strong> Track symptoms, access evidence-based resources, and monitor your progress with comprehensive analytics.
              </p>

              <div style={{ textAlign: "left", margin: "20px 0", padding: "20px", borderRadius: "10px" }}>
                <p><strong>✅ Symptom/trigger tracking</strong></p>
                <p><strong>✅ Evidence-based resources</strong></p>
                <p><strong>✅ Progress visualization</strong></p>
                <p><strong>✅ Therapeutic exercises</strong></p>
              </div>

              <a
                href="https://play.google.com/store/apps/details?id=com.olivier7355.ocdserenitymobile"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "15px 25px",
                  borderRadius: "25px",
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginTop: "20px",
                  transition: "all 0.3s ease"
                }}
              >
                📱 Download FREE Now On Google Play Store
              </a>
              {/* QR Code for Toolkit App */}
              <div style={{ marginTop: "20px", textAlign: "center" }}>
                <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                  📱 Scan with your phone:
                </p>
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=https://play.google.com/store/apps/details?id=com.olivier7355.ocdserenitymobile`}
                  alt="QR Code for OCD Complete Therapy Toolkit"
                  style={{
                    width: "120px",
                    height: "120px",
                    border: "2px solid #007bff",
                    borderRadius: "10px",
                    padding: "5px",
                    backgroundColor: "white"
                  }}
                />
              </div>
            </div>

            {/* App 2 - ERP */}
            <div style={{
              padding: "30px",
              borderRadius: "15px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              textAlign: "center",
              border: "2px solid #28a745"
            }}>
              <div style={{ backgroundColor: "#28a745", color: "white", padding: "10px 20px", borderRadius: "20px", display: "inline-block", marginBottom: "20px", fontSize: "14px", fontWeight: "bold" }}>
                ERP SPECIALIST
              </div>
              <h3 style={{ color: "#28a745", marginBottom: "20px" }}>
                <strong>📊 Exposure Hierarchy Builder</strong>
                <br /><br />
              </h3>
              <a
                href="https://play.google.com/store/apps/details?id=com.ocdserenity.exposurehierarchy"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={exposureImage}
                  alt="OCD Exposure Hierarchy Builder App"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "15px",
                    margin: "20px 0",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)"
                  }}
                />
              </a>
              <p style={{ fontSize: "16px", lineHeight: "1.6", marginBottom: "20px" }}>
                <strong>Perfect for ERP therapy!</strong> Build custom exposure hierarchies, track SUDS levels, and monitor your progress through graduated exposures.
                <br /><br />
              </p>

              <div style={{ textAlign: "left", margin: "20px 0", padding: "20px", borderRadius: "10px" }}>
                <p><strong>✅ Custom exposures</strong></p>
                <p><strong>✅ SUDS level tracking</strong></p>
                <p><strong>✅ Progress monitoring</strong></p>
                <p><strong>✅ Therapist collaboration</strong></p>
              </div>

              <a
                href="https://play.google.com/store/apps/details?id=com.ocdserenity.exposurehierarchy"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  backgroundColor: "#28a745",
                  color: "white",
                  padding: "15px 25px",
                  borderRadius: "25px",
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginTop: "20px",
                  transition: "all 0.3s ease"
                }}
              >
                📊 Download ERP FREE Now On Google Play Store
              </a>
              {/* QR Code for ERP App */}
              <div style={{ marginTop: "20px", textAlign: "center" }}>
                <p style={{ fontSize: "14px", marginBottom: "10px" }}>
                  📱 Scan with your phone:
                </p>
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=https://play.google.com/store/apps/details?id=com.ocdserenity.exposurehierarchy`}
                  alt="QR Code for OCD Exposure Hierarchy Builder"
                  style={{
                    width: "120px",
                    height: "120px",
                    border: "2px solid #28a745",
                    borderRadius: "10px",
                    padding: "5px",
                    backgroundColor: "white"
                  }}
                />
              </div>
            </div>
          </div>

          {/* Add why choose both section */}
          <div style={{ padding: "30px", borderRadius: "15px", margin: "40px 0", textAlign: "center" }}>
            <h3 style={{ color: "#0066cc", marginBottom: "15px" }}>💡 Why Download Both Apps?</h3>
            <p style={{ fontSize: "18px", maxWidth: "700px", margin: "0 auto" }}>
              Use the <strong>Complete Toolkit</strong> for daily symptom tracking and resources, then switch to the <strong>Exposure Builder</strong> during ERP sessions with your therapist. They work perfectly together!
            </p>
          </div>
        </section>

        <BookPromo coverImage={bookCover} />

        {/* Custom Implementation Section for Therapeutic Centers */}
        <section className="homepage-header" style={{
          backgroundColor: "#2e2e2e",
          padding: "50px 30px",
          borderRadius: "20px",
          border: "2px solid #6c757d"
        }}>
          <div style={{ textAlign: "center", maxWidth: "1000px", margin: "0 auto" }}>
            <div style={{
              backgroundColor: "#6c757d",
              color: "white",
              padding: "10px 25px",
              borderRadius: "25px",
              display: "inline-block",
              marginBottom: "30px",
              fontSize: "16px",
              fontWeight: "bold"
            }}>
              🏢 FOR THERAPEUTIC CENTERS
            </div>

            <h2 style={{ marginBottom: "30px" }}>
              Custom Enterprise Solutions
            </h2>

            <p style={{
              fontSize: "20px",
              lineHeight: "1.6",
              marginBottom: "40px",
              maxWidth: "800px",
              margin: "0 auto 40px auto"
            }}>
              We offer <strong>customized implementations for therapeutic centers</strong>. Beyond our standard consumer app, we can develop a dedicated version with your center's specific requirements, including custom user databases and specialized features.
            </p>

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "30px",
              margin: "40px 0"
            }}>
              <div style={{
                backgroundColor: "#3e3e3e",
                padding: "10px",
                borderRadius: "15px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                textAlign: "center"
              }}>
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>🏥</div>
                <h3 style={{ marginBottom: "15px" }}>White-Label Solutions</h3>
                <p style={{ textAlign: "left", fontSize: "16px" }}>
                  Branded with your center's logo and identity, seamlessly integrated into your existing workflow.
                </p>
              </div>

              <div style={{
                backgroundColor: "#3e3e3e",
                padding: "10px",
                borderRadius: "15px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                textAlign: "center"
              }}>
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>🗄️</div>
                <h3 style={{ marginBottom: "15px" }}>Custom Databases</h3>
                <p style={{ textAlign: "left", fontSize: "16px" }}>
                  Dedicated user management systems tailored to your center's patient population and protocols.
                </p>
              </div>

              <div style={{
                backgroundColor: "#3e3e3e",
                padding: "10px",
                borderRadius: "15px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                textAlign: "center"
              }}>
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>⚙️</div>
                <h3 style={{ marginBottom: "15px" }}>Specialized Features</h3>
                <p style={{ textAlign: "left", fontSize: "16px" }}>
                  Custom tools and workflows designed specifically for your center's treatment approaches and requirements.
                </p>
              </div>
            </div>

            <div style={{
              backgroundColor: "#3e3e3e",
              padding: "25px",
              borderRadius: "15px",
              margin: "30px 0",
              textAlign: "left"
            }}>
              <h4 style={{ marginBottom: "15px", textAlign: "center" }}>
                Enterprise Features Include:
              </h4>
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "10px"
              }}>
                <p style={{ textAlign: "left", margin: "5px 0" }}>✅ <strong>Multi-therapist management</strong></p>
                <p style={{ textAlign: "left", margin: "5px 0" }}>✅ <strong>Advanced reporting & analytics</strong></p>
                <p style={{ textAlign: "left", margin: "5px 0" }}>✅ <strong>Custom branding & UI</strong></p>
                <p style={{ textAlign: "left", margin: "5px 0" }}>✅ <strong>Integration with existing systems</strong></p>
                <p style={{ textAlign: "left", margin: "5px 0" }}>✅ <strong>Enhanced security protocols</strong></p>
                <p style={{ textAlign: "left", margin: "5px 0" }}>✅ <strong>Dedicated support</strong></p>
              </div>
            </div>

            <div style={{ textAlign: "center", marginTop: "40px" }}>
              <a
                href="mailto:contact@ocdserenity.com?subject=Custom Enterprise Solution Inquiry"
                style={{
                  display: "inline-block",
                  backgroundColor: "#6c757d",
                  color: "white",
                  padding: "18px 35px",
                  borderRadius: "30px",
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "10px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.2)"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#5a6268"}
                onMouseOut={(e) => e.target.style.backgroundColor = "#6c757d"}
              >
                🏢 Contact Us for Enterprise Solutions
              </a>
              <br />
              <p style={{
                fontSize: "14px",
                color: "#6c757d",
                marginTop: "15px",
                fontStyle: "italic"
              }}>
                Schedule a consultation to discuss your center's specific needs
              </p>
            </div>
          </div>
        </section>

        <section className="homepage-header">
          <h2>Purpose-Built for OCD Treatment</h2>
          <p>
            Unlike general mental health platforms, OCDSerenity is designed
            specifically for the unique challenges of OCD treatment, providing
            specialized tools that convert patient experiences into actionable
            clinical insights.
          </p>
          <br />
          <br />
          <div style={{ maxWidth: "900px", height: "auto", margin: "auto" }}>
            <img
              src={therapistImage1}
              alt="OCD Specialist using platform"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
          <br />
          <p>Our specialized clinical features include:</p>
          <br />
          <h3>
            <strong>For OCD Treatment Specialists</strong>
          </h3>
          <p>
            OCDSerenity enhances your clinical expertise with purpose-built
            tools that streamline OCD treatment and improve patient outcomes:
          </p>
          <br />
          <p>
            ✅ <strong>Evidence-Based Treatment Support</strong>: Tools
            specifically designed to enhance ERP, CBT, and other evidence-based
            OCD protocols.
          </p>
          <br />
          <p>
            ✅ <strong>Clinical Management Dashboard</strong>: Easily track
            patient progress across multiple OCD dimensions, with specialized
            visualization of compulsion frequency, severity, and response to
            treatment.
          </p>
          <br />
          <p>
            ✅ <strong>Treatment Continuity</strong>: Extend your therapeutic
            reach between sessions with structured support tools that reinforce
            clinical protocols.
          </p>
          <br />
          <p>
            ✅ <strong>Data-Driven Insights</strong>: Transform subjective
            patient experiences into objective, trackable data to identify
            patterns and treatment effectiveness.
          </p>
          <br />
          <br />
          <p>
            All patient data is securely encrypted and stored in compliance with
            HIPAA standards, creating a trusted environment focused on clinical
            excellence and patient progress.
          </p>
          <div style={{ textAlign: "center", marginTop: "30px" }}>
            <Link
              to="/registerastherapist"
              style={{
                display: "inline-block",
                backgroundColor: "#17a2b8",
                color: "white",
                padding: "15px 30px",
                border: "none",
                borderRadius: "25px",
                fontSize: "18px",
                fontWeight: "bold",
                textDecoration: "none",
                cursor: "pointer",
                transition: "all 0.3s ease"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#138496"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#17a2b8"}
            >
              🩺 Register as Therapist - FREE
            </Link>
          </div>
          <br />
          <h3>
            <strong>For Individuals with OCD</strong>
          </h3>
          <p>
            Our platform supports your treatment journey with specialized tools
            that work in harmony with your therapist's approach:
          </p>
          <br />
          <div style={{ maxWidth: "900px", height: "auto", margin: "auto" }}>
            <img
              src={patientImage1}
              alt="Patient using OCD Serenity"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
          <div style={{ maxWidth: "900px", height: "auto", margin: "auto" }}>
            <img
              src={patientImage2}
              alt="Patient tracking progress"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
          <br />
          <br />
          <p>
            ✅ <strong>Personalized Dashboard</strong>: Your central hub for
            tracking progress and managing OCD-specific tools between therapy
            sessions.
          </p>
          <br />
          <p>
            ✅ <strong>Evidence-Based Resources</strong>: Access to specialized
            OCD content curated from trusted clinical sources to complement your
            treatment.
          </p>
          <br />
          <p>
            ✅ <strong>OCD-Specific Tracking Tools</strong>: Purpose-built tools
            for monitoring triggers, intrusive thoughts, and compulsions to
            recognize patterns and progress.
          </p>
          <br />
          <p>
            ✅ <strong>Exposure Hierarchy Builder</strong>: Collaboratively
            develop and track graduated exposure exercises with your therapist,
            following evidence-based ERP protocols.
          </p>
          <br />
          <p>
            ✅ <strong>SUDS Integration</strong>: Track distress levels during
            exposure exercises and daily activities to objectively measure
            progress and identify patterns.
          </p>
          <div style={{ textAlign: "center", marginTop: "30px" }}>
            <Link
              to="/registerasclient"
              style={{
                display: "inline-block",
                backgroundColor: "#17a2b8",
                color: "white",
                padding: "15px 30px",
                border: "none",
                borderRadius: "25px",
                fontSize: "18px",
                fontWeight: "bold",
                textDecoration: "none",
                cursor: "pointer",
                transition: "all 0.3s ease"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#138496"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#17a2b8"}
            >
              👩‍⚕️ Register as Individual - FREE
            </Link>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Homepage;